import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { IpPublicService } from '../../../../services/ip-public.service';
import { ModalService } from '../../../../services/modal.service';
import { AlertService } from '../../../../services/alert.service';
import { AmbRolUsuarioService } from '../../services/amb.rol.usuario.service';
import { AplicacionesService } from '../../services/aplicaciones.service';
import { AplicacionPermisoService } from '../../services/aplicacion-permiso.service';
import { PermisoService } from '../../services/permiso.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map } from 'rxjs';
import { RolService } from '../../services/rol.service';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { tieneRolId } from 'src/app/redux/usuario/usuario.selectors';

@Component({
  selector: 'roles-aplicaciones',
  templateUrl: './roles-aplicaciones.component.html',
  styleUrls: ['./roles-aplicaciones.component.scss'],
})
export class RolesAplicacionesComponent implements OnInit, OnDestroy {
  breadCrumbItems = [{ label: 'Administración Sistema' }, { label: 'Administración' }, { label: 'Roles-aplicaciones', active: true }];
  public formAppPermisos!: UntypedFormGroup;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  public dataRoles: any[] = [];
  public dataAplicaciones: any[] = [];
  public dataRolesAppPermisos: any[] = [];
  public resultadoRolesAppPermisos: any[] = [];
  public dataAppPermisos: any[] = [];
  public dataPermisos: any[] = [];
  public dataPushRolApp: any[] = [];
  private idDeleteRegister: number = 0;
  public idSprAppPermiso: number = 0;
  public idSprUsuario: number = 0;
  public selectItems: any[] = [];
  public nameModal: string = 'modalNewEdit'
  nameApp = 'Roles-aplicaciones';
  public rolSeleccionado = []
  public permisosBorrar = []
  public getPermisos = []
  public opciones: any[] = []
  public getPermisoSave: any[] = []

  currentUserRedux: UsuarioRedux = null;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  constructor(
    private fb: FormBuilder,
    private rolService: RolService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private aplicacionesService: AplicacionesService,
    private appPermisosService: AplicacionPermisoService,
    private permisosService: PermisoService,
    private ambRolUsuarioService: AmbRolUsuarioService,
    private store: Store<AppState>

  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get rolForm() {
    return this.formAppPermisos.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
       //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setForm() {
    this.formAppPermisos = this.fb.group({
      idSprAppPermiso: [],
      idSprRol: ['', [Validators.required]],
      idSprAplicacion: ['', [Validators.required]],
      //idSprPermiso: ['', [Validators.required]],
      idSprPermiso: new FormArray([]),
      estado: ['', [Validators.required]],
    });

    this.formAppPermisos.patchValue({
      estado: this.selectItems[0].value,
    });
  }

  ngOnInit(): void {
    this.getIpPublic();
    this.initApp();
    this.store.select("usuarioApp").subscribe(response => {
      this.currentUserRedux = response.currentUser
      this.idSprUsuario = response.currentUser.idSprUsuario;
    })
  }

  initApp() {
    this.listDataApp();
    this.setDataTable();
    this.listPermisos();
    this.setForm();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  listDataApp() {
    forkJoin([
      this.aplicacionesService.list(),
      this.permisosService.list(),
      this.rolService.list(),
      this.appPermisosService.list(),
    ]).pipe(map(
      ([aplicaciones, permisos, roles, appPermisos]) => {
        this.dataAplicaciones = aplicaciones;
        this.dataPermisos = permisos;
        this.dataRoles = roles;
        this.dataAppPermisos = appPermisos;
        this.setDataMaping();
      })).subscribe();
  }

  setDataMaping() {
    let dataProcess = [];
    let permisoString: string = '';
    let permisosObj = [];
    let i, j, k, m;
    for (i = 0; i < this.dataRoles.length; i++) {
      for (j = 0; j < this.dataAppPermisos.length; j++) {
        if (this.dataRoles[i].idSprRol === this.dataAppPermisos[j].idSprRol) {
          for (k = 0; k < this.dataAplicaciones.length; k++) {
            if (this.dataAplicaciones[k].idSprAplicacion === this.dataAppPermisos[j].idSprAplicacion) {
              for (m = 0; m < this.dataPermisos.length; m++) {
                if (this.dataPermisos[m].idSprPermiso === this.dataAppPermisos[j].idSprPermiso) {
                  dataProcess.push({
                    idSprAppPermiso: this.dataAppPermisos[j].idSprAppPermiso,
                    nombreRol: this.dataRoles[i].nombre,
                    nombreAplicacion: this.dataAplicaciones[k].nombre,

                    idSprAplicacion: this.dataAppPermisos[j].idSprAplicacion,
                    permisos: {
                      idSprAppPermiso: this.dataAppPermisos[j].idSprAppPermiso,
                      idSprPermiso: this.dataPermisos[m].idSprPermiso,
                      nombrePermiso: this.dataPermisos[m].nombre,
                    },
                    estado: this.dataAppPermisos[j].estado,
                    idSprRol: this.dataRoles[i].idSprRol,
                  })
                }
              }
            }
          }
        }
      }
    }
    this.dataRolesAppPermisos = dataProcess;
    this.verificaDuplicados()
  }

  verificaDuplicados() {
    let datosAgrupados: any = {};
    this.dataRolesAppPermisos.forEach(item => {
      const clave = `${item.idSprRol, item.nombreRol}-${item.idSprAplicacion, item.nombreAplicacion}`;

      if (!datosAgrupados[clave]) {
        datosAgrupados[clave] = {
          idSprAppPermiso: item.idSprAppPermiso,
          idSprRol: item.idSprRol,
          nombreRol: item.nombreRol,
          idSprAplicacion: item.idSprAplicacion,
          nombreAplicacion: item.nombreAplicacion,
          estado: item.estado,
          permisos: []
        };
      }
      datosAgrupados[clave].permisos.push(item.permisos);
    });
    // Convertir el objeto a un arreglo de objetos
    this.resultadoRolesAppPermisos = Object.values(datosAgrupados);
    this.reDrawDataTable();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        if (dtInstance) {
          dtInstance.destroy();
          this.dtTrigger.next(null);
          window.location.reload();
        }
      }).catch(error => {
        window.location.reload();
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  listPermisos() {
    this.permisosService.list().subscribe(resp => {
      this.getPermisos = resp
    })
  }

  onChangePermisos(event: any, id: any) { //boton chekbox
    let indice = -1;
    for (let i = 0; i < this.opciones.length; i++) {
      if (this.opciones[i].idSprPermiso === id) {
        indice = i;
        break; // Si encuentra sal del bucle
      }
    }
    if (indice === -1) {
      this.opciones.push({
        idSprPermiso: id,
        checked: event.target.checked,
      });
    } else {
      this.opciones.splice(indice, 1);
    }
  }

  setDataAtribucionesCheck(dataRow: any) {
    let atribucionesFixed = this.getPermisos;
    let checked: boolean = false;
    for (let i = 0; i < this.getPermisos.length; i++) {
      for (let j = 0; j < dataRow.length; j++) {
        if (this.getPermisos[i].idSprPermiso === dataRow[j].idSprPermiso) {
          checked = true;
        }
      }
      atribucionesFixed[i].checked = checked;
      checked = false;
    }
  }



  onSubmit(rolSeleccionado: any) {
    this.submitted = true;
    this.formAppPermisos.value.usuario = this.currentUser.idSprUsuario;
    this.formAppPermisos.value.ip = this.ipAddress;
    this.formAppPermisos.value.idSprUsuario = this.idSprUsuario;
    this.formAppPermisos.value.delLog = 'N';

    if (!this.formAppPermisos.invalid) {
      if (this.formAppPermisos.value.idSprAppPermiso == null || this.formAppPermisos.value.idSprAppPermiso == " ") {
        let permiso = this.opciones;
        let dataPermisoApp
        for (let x = 0; x < permiso.length; x++) {
          dataPermisoApp = {
            idSprAplicacion: this.formAppPermisos.value.idSprAplicacion,
            idSprRol: this.formAppPermisos.value.idSprRol,
            idSprUsuario: this.currentUser.idSprUsuario,
            idSprPermiso: permiso[x].idSprPermiso,
            estado: '1',
            usuario: this.currentUser.idSprUsuario,
            ip: this.ipAddress,
          }
          this.appPermisosService.create(dataPermisoApp).subscribe(
            (resp) => {
              this.initApp();
              this.closeModal();
              this.alert.createOk();
              /**
               * * Función redux para agregar los permisos y la aplicación cuando el usuario actaul posee el rol seleccionado
               */
              this.store.pipe(select(tieneRolId, { idSprRol: resp.idSprRol })).subscribe(response => {
                if (response) {
                  //this.store.dispatch(addAplicacion({idSprAplicacion:resp.idSprAplicacion, idSprRol: resp.idSprRol }))
                }
              })
              // Fin función redux -->>

            },
            (err) => {
              this.alert.createError();
            }
          );
        }
      } else {
        let permisoEditar = this.opciones;
        let dataPermisoAppActualizaPush = [];
        let verifica: boolean = false;
        for (let i = 0; i < permisoEditar.length; i++) {
          for (let j = 0; j < this.getPermisoSave.length; j++) {
            if (permisoEditar[i].checked == false && this.getPermisoSave[j].idSprPermiso == permisoEditar[i].idSprPermiso) {
              let dataPermisoAppActualiza = {
                idSprAppPermiso: this.getPermisoSave[j].idSprAppPermiso,
                idSprAplicacion: this.formAppPermisos.value.idSprAplicacion,
                idSprRol: this.formAppPermisos.value.idSprRol,
                idSprUsuario: this.currentUser.idSprUsuario,
                idSprPermiso: permisoEditar[i].idSprPermiso,
                estado: '1',
                delLog: 'S',
                usuario: this.currentUser.idSprUsuario,
                ip: this.ipAddress,
              }
              //dataPermisoAppActualizaPush.push(dataPermisoAppActualiza)
              this.appPermisosService.update(dataPermisoAppActualiza).subscribe(
                (resp) => {
                  verifica = false
                },
                (err) => {
                  verifica = true
                }
              );
            }
          }
          if (permisoEditar[i].checked == true) {
            let dataPermisoAppCreate = {
              idSprAplicacion: this.formAppPermisos.value.idSprAplicacion,
              idSprRol: this.formAppPermisos.value.idSprRol,
              idSprUsuario: this.currentUser.idSprUsuario,
              idSprPermiso: permisoEditar[i].idSprPermiso,
              estado: '1',
              usuario: this.currentUser.idSprUsuario,
              ip: this.ipAddress,
            }
            this.appPermisosService.create(dataPermisoAppCreate).subscribe(
              (resp) => {
                verifica = false
              },
              (err) => {
                verifica = true
              }
            );
          }
        }

        if (verifica == false) {
          this.initApp();
          this.closeModal();
          this.alert.updateOk();
        } else {
          this.alert.updateError();
        }
      }
    } else {
      return;
    }
  }

  edit(obj: any) {
    this.getPermisoSave = obj.permisos
    this.setDataAtribucionesCheck(obj.permisos)
    this.openModal();
    this.formAppPermisos.patchValue({
      idSprAppPermiso: obj.idSprAppPermiso,
      idSprRol: obj.idSprRol,
      idSprPermiso: obj.permisos,
      idSprAplicacion: obj.idSprAplicacion,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete-app-permiso');
    this.idDeleteRegister = idRegister;
  }

  verifyAmbRolUsuario() {
    return this.ambRolUsuarioService.list(`?idSprRol=${this.idDeleteRegister}&delLog=N`).toPromise();
  }


  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    dataVerifyRelacion = await this.verifyAmbRolUsuario();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";

    if (confirmDelete) {
      this.appPermisosService.delete(
        {
          "idSprAppPermiso": this.idDeleteRegister,
          "usuario": this.currentUser.idSprUsuario,
          "delLog": "S",
          "ip": this.ipAddress
        }
      )
        .subscribe(resp => {
          this.initApp();
          this.modal.close()
          this.alert.deleteOk();
        }, (err) => {
          this.alert.deleteError();
        });
    }
    else {
      this.alert.warning("¡Atención!", "No se puede borrar este registro, existe USUARIOS relacionados con este ROL.");
    }
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }
  closeModal() {
    this.modal.closeId(this.nameModal);
    this.opciones = [];
    this.getPermisos = [];
    this.listPermisos();
  }


  onResetForm() {
    this.submitted = false;
    this.formAppPermisos.reset();
  }

}
